/**
 * CanaryPop - límites por pedido mediante etiquetas limite-1 ... limite-5.
 * Controla formularios de producto, botones rápidos y el carrito visible.
 */
(function () {
  'use strict';

  var MESSAGE_PREFIX = 'Este producto está limitado a un máximo de ';

  function asInt(value, fallback) {
    var parsed = parseInt(value, 10);
    return Number.isFinite(parsed) ? parsed : fallback;
  }

  function showNotice(container, message) {
    if (!container) return;
    var notice = container.querySelector('.canarypop-limit-notice');
    if (!notice) {
      notice = document.createElement('div');
      notice.className = 'canarypop-limit-notice canarypop-limit-notice--error';
      notice.setAttribute('role', 'alert');
      container.appendChild(notice);
    }
    notice.textContent = message;
    notice.hidden = false;
    window.clearTimeout(notice._cpTimer);
    notice._cpTimer = window.setTimeout(function () {
      notice.classList.remove('canarypop-limit-notice--flash');
    }, 2500);
    notice.classList.add('canarypop-limit-notice--flash');
  }

  function getLimitHolder(element) {
    return element && element.closest('[data-canarypop-product-limit]');
  }

  async function getCart() {
    var response = await fetch(window.Shopify && Shopify.routes ? Shopify.routes.root + 'cart.js' : '/cart.js', {
      credentials: 'same-origin',
      headers: { 'Accept': 'application/json' }
    });
    if (!response.ok) throw new Error('No se pudo consultar el carrito.');
    return response.json();
  }

  function cartQuantityForProduct(cart, productId) {
    return (cart.items || []).reduce(function (total, item) {
      return total + (String(item.product_id) === String(productId) ? item.quantity : 0);
    }, 0);
  }

  function normalizeProductQuantityInputs(scope) {
    (scope || document).querySelectorAll('[data-canarypop-product-limit]').forEach(function (holder) {
      var limit = asInt(holder.dataset.canarypopProductLimit, 0);
      if (!limit) return;
      holder.querySelectorAll('input[name="quantity"]').forEach(function (input) {
        input.setAttribute('max', String(limit));
        input.dataset.canarypopLimit = String(limit);
        input.addEventListener('input', function () {
          var value = asInt(input.value, 1);
          if (value > limit) {
            input.value = String(limit);
            showNotice(holder, MESSAGE_PREFIX + limit + ' unidades por pedido.');
          }
          if (value < 1) input.value = '1';
        });
      });
    });
  }

  async function handleAddSubmit(event) {
    var form = event.target.closest('form[action*="/cart/add"]');
    if (!form) return;
    var holder = getLimitHolder(form) || form;
    var limit = asInt(holder.dataset.canarypopProductLimit || form.dataset.canarypopProductLimit, 0);
    var productId = holder.dataset.canarypopProductId || form.dataset.canarypopProductId;
    if (!limit || !productId) return;

    event.preventDefault();
    event.stopImmediatePropagation();

    var quantityInput = form.querySelector('[name="quantity"]');
    var requested = asInt(quantityInput ? quantityInput.value : 1, 1);
    requested = Math.max(1, Math.min(requested, limit));
    if (quantityInput) quantityInput.value = String(requested);

    try {
      var cart = await getCart();
      var alreadyInCart = cartQuantityForProduct(cart, productId);
      var remaining = limit - alreadyInCart;

      if (remaining <= 0) {
        showNotice(holder, 'Ya tienes el máximo permitido (' + limit + ') de este producto en el carrito.');
        return;
      }

      if (requested > remaining) {
        requested = remaining;
        if (quantityInput) quantityInput.value = String(requested);
        showNotice(holder, 'Solo puedes añadir ' + remaining + ' unidad' + (remaining === 1 ? '' : 'es') + ' más de este producto.');
      }

      var formData = new FormData(form);
      formData.set('quantity', String(requested));
      var response = await fetch(form.action, {
        method: 'POST',
        body: formData,
        credentials: 'same-origin',
        headers: { 'Accept': 'application/json' }
      });

      if (!response.ok) {
        var errorData = {};
        try { errorData = await response.json(); } catch (ignore) {}
        throw new Error(errorData.description || 'No se pudo añadir el producto.');
      }

      window.location.href = (window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart';
    } catch (error) {
      showNotice(holder, error.message || 'No se pudo añadir el producto. Inténtalo de nuevo.');
    }
  }

  function normalizeCartInput(input, showMessage) {
    var limit = asInt(input.dataset.canarypopLimit, 0);
    if (!limit) return true;
    var value = asInt(input.value, 1);
    if (value > limit) {
      input.value = String(limit);
      if (showMessage) {
        showNotice(input.closest('.canarypop-cart-limit-row') || input.parentElement, MESSAGE_PREFIX + limit + ' unidades por pedido.');
      }
      return false;
    }
    if (value < 0) input.value = '0';
    return true;
  }

  function bindCartLimits() {
    document.querySelectorAll('.canarypop-cart-limit-input[data-canarypop-limit]').forEach(function (input) {
      input.setAttribute('max', input.dataset.canarypopLimit);
      input.addEventListener('input', function () { normalizeCartInput(input, true); });
      input.addEventListener('change', function () { normalizeCartInput(input, true); });
    });

    var cartForm = document.getElementById('cartform');
    if (cartForm) {
      cartForm.addEventListener('submit', function (event) {
        var valid = true;
        cartForm.querySelectorAll('.canarypop-cart-limit-input[data-canarypop-limit]').forEach(function (input) {
          if (!normalizeCartInput(input, true)) valid = false;
        });
        if (!valid) {
          event.preventDefault();
          event.stopImmediatePropagation();
        }
      }, true);
    }
  }

  function init() {
    normalizeProductQuantityInputs(document);
    bindCartLimits();
    document.addEventListener('submit', handleAddSubmit, true);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
